import { j as o } from "./jsx-runtime-C5mzlN2N.js";
import { useMemo as b } from "react";
import e from "styled-components";
import { r as C } from "./palettes-Bw24w7AF.js";
import { createPortal as y } from "react-dom";
import "./components/Theme/themes.es.js";
import { getZIndexes as j, getRadii as M, getPaletteBackground as u, getBreakpointMediaQuery as p, getSpacings as t, getEffects as x, getPaletteForeground as $ } from "./components/Theme/utils.es.js";
import "./CssBaseline-Bp4jdUgb.js";
import { sizeStyles as k, variantStyles as B, sideModalContentAnimations as z, sideModalPositionStyles as I } from "./components/Modal/styles.es.js";
import { I as P } from "./IconButton-g0G4rvcV.js";
import { I as w } from "./CheckIcon-XCAywhAi.js";
import "./components/Icon/countryVariants.es.js";
import { D as v } from "./Divider-B6iiHZcG.js";
import { B as A } from "./Button-DkQlhrIH.js";
const D = e.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  &[data-is-open='false'] {
    transition-property: visibility;
    transition-delay: 150ms;
    visibility: hidden;
  }

  z-index: ${j("modal")};
`, N = (i) => {
  const {
    isOpen: n,
    className: r,
    children: s
  } = i;
  return y(
    /* @__PURE__ */ o.jsx(
      D,
      {
        "data-is-open": n,
        className: r,
        children: s
      }
    ),
    document.body
  );
}, O = e.div`
  position: relative;

  border-radius: ${M("xl")};
  background-color: ${u("default")};

  ${(i) => i.$size ? k[i.$size] : void 0}

  ${p("min", "lg")} {
    ${(i) => B[i.$variant]}
    ${(i) => i.$variant === "side" ? z[i.$position] : void 0}
  }
`, S = e.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;

  padding: ${t("4xl")} ${t("3xl")};

  ${p("min", "lg")} {
    ${(i) => i.$variant === "side" ? I[i.$position] : void 0}
  }

  ${p("max", "lg")} {
    align-items: flex-end;

    padding: ${t("xl")};
    padding-bottom: ${t("8xl")};
  }
`, F = e.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  backdrop-filter: ${(i) => `blur(${x("blur.sm")(i)})`};
  -webkit-backdrop-filter: ${(i) => `blur(${x("blur.sm")(i)})`};
  background-color: ${(i) => C(u("overlay")(i), 0.7)};

  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  &[data-is-open='false'] {
    opacity: 0;
  }
`, ti = (i) => {
  const {
    children: n,
    className: r,
    size: s,
    variant: a = "primary",
    onClose: m,
    ...l
  } = i, d = i.variant === "side" ? i.position : void 0, c = b(() => a === "primary" ? {
    $variant: a
  } : {
    $variant: a,
    $position: d || "right"
  }, [
    a,
    d
  ]);
  return /* @__PURE__ */ o.jsx(
    N,
    {
      ...l,
      children: /* @__PURE__ */ o.jsxs(
        S,
        {
          ...c,
          children: [
            /* @__PURE__ */ o.jsx(
              F,
              {
                "data-is-open": l.isOpen,
                onClick: m
              }
            ),
            /* @__PURE__ */ o.jsx(
              O,
              {
                "data-is-open": l.isOpen,
                ...c,
                $size: s,
                className: r,
                children: l.isOpen && n
              }
            )
          ]
        }
      )
    }
  );
}, V = e.div`
  position: relative;
  padding: ${t("3xl")};
  padding-bottom: ${t("none")};
`, q = e(P)`
  top: 0;
  right: 0;
  position: absolute;

  padding: ${t("none")};
  margin-top: ${t("3xl")};
  margin-right: ${t("3xl")};
  color: ${$("quaternary.default")};
  &:hover {
    color: ${$("quaternary.hover")};
  }
`, ni = (i) => {
  const {
    children: n,
    className: r,
    isCloseIconVisible: s,
    isDividerVisible: a = !0
  } = i;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(V, { className: r, children: [
      s && /* @__PURE__ */ o.jsx(q, { variant: "text", onClick: i.onCloseIconClick, children: /* @__PURE__ */ o.jsx(w, { variant: "close" }) }),
      n
    ] }),
    a && /* @__PURE__ */ o.jsx(v, {})
  ] });
}, E = e.div`
  padding: ${t("3xl")};
`, ei = (i) => {
  const {
    className: n,
    children: r
  } = i;
  return /* @__PURE__ */ o.jsx(E, { className: n, children: r });
}, H = e.div`
  display: flex;
  gap: ${t("lg")};
  flex-direction: ${(i) => i.$orientation};
`, R = e.div`
  padding: ${t("3xl")};
  padding-top: ${t("none")};
`, g = e(A)`
  width: 100%;
  max-width: 170px;
`, ri = (i) => {
  const {
    children: n,
    className: r,
    onCancel: s,
    onConfirm: a,
    buttonOrientation: m,
    cancelText: l = "Cancel",
    confirmText: d = "Confirm",
    isDividerVisible: c = !0
  } = i, f = !!n, h = () => /* @__PURE__ */ o.jsxs(H, { $orientation: m ?? "row", children: [
    /* @__PURE__ */ o.jsx(
      g,
      {
        size: "lg",
        color: "gray",
        variant: "outlined",
        onClick: s,
        children: l
      }
    ),
    /* @__PURE__ */ o.jsx(g, { size: "lg", onClick: a, children: d })
  ] });
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    c && /* @__PURE__ */ o.jsx(v, {}),
    /* @__PURE__ */ o.jsx(R, { className: r, children: f ? n : /* @__PURE__ */ o.jsx(h, {}) })
  ] });
};
export {
  N as B,
  ti as M,
  ni as a,
  ei as b,
  ri as c
};
